import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import Mobialis from 'mobialis';
import { sync } from 'vuex-router-sync';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import VueSecureHTML from 'vue-html-secure';
import VueCookies from 'vue-cookies';
// eslint-disable-next-line no-unused-vars
import bootstrap from 'bootstrap';
import InlineSvg from 'vue-inline-svg';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faVolume,
  faArrowAltCircleDown,
  faShieldAlt,
  faStars,
  faTachometerSlow,
  faThumbsUp,
  faTachometerFast,
  faExchangeAlt,
  faShieldCheck,
  faDollarSign,
  faCar,
  faCarCrash,
  faChevronDown,
  faCommentAltSmile,
  faInfoCircle,
  faChevronRight,
  faChevronLeft,
  faFire,
  faEye,
  faBadgeDollar,
} from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle as faInfoCircleSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import httpClient from './services/httpClient';
import globalDirectives from '@/utils/directives';
import DemoComponent from '@/components/DemoComponent.vue';
// eslint-disable-next-line import/extensions
import { faAvSpin } from '@/assets/fa/av-spin.js';
import { routingMixin, mediaQuery, enumMixin } from '@/mixins';
import log from '@/services/log';
import router from './router/index';
import store from './store/index';
import i18n from './i18n';
import './services/vueAnalytics';
import App from './App.vue';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';
import './services/bugsnag';

library.add(
  faVolume,
  faTachometerSlow,
  faArrowAltCircleDown,
  faShieldAlt,
  faStars,
  faThumbsUp,
  faTachometerFast,
  faExchangeAlt,
  faShieldCheck,
  faDollarSign,
  faCar,
  faCarCrash,
  faChevronDown,
  faCommentAltSmile,
  faInfoCircle,
  faChevronRight,
  faChevronLeft,
  faFire,
  faEye,
  faBadgeDollar,
  faInfoCircleSolid,
  faAvSpin
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('demo-component', DemoComponent);
Vue.component('inline-svg', InlineSvg);

if (process.env.NODE_ENV !== 'production') {
  Vue.config.productionTip = false;
}

// Vue.config.devtools = true;// TODO: disable for prod
sync(store, router);

Vue.use(VueSecureHTML);
Vue.use(VueCookies);

Vue.mixin(routingMixin);
Vue.mixin(mediaQuery);
Vue.mixin(enumMixin);

Vue.prototype.$log = log;

Vue.use(globalDirectives);

httpClient.interceptors.request.use(
  configuration => {
    const token = store.state.lead.consumerJWT;
    if (token) {
      // eslint-disable-next-line no-param-reassign
      configuration.headers.Authorization = `Bearer ${token}`;
    }
    return configuration;
  },
  error => Promise.reject(error)
);

const app = new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
});

router.onReady(() => {
  const { language } = app.$route.query;
  // default to Canadian English
  app.$i18n.locale = language || 'en_CA';

  // Pass the Mobialis vee-validate locale option
  Vue.use(Mobialis, {
    locale: language || 'en_CA',
  });

  // make sure we can use it in our components
  Vue.use(AirbnbStyleDatepicker, {
    colors: {
      selected: '#007bc7',
      inRange: '#007bc7',
      selectedText: '#fff',
      text: '#565a5c',
      inRangeBorder: '#007bc7',
      disabled: '#fff',
      hoveredInRange: '#f6faff',
    },
    sundayFirst: true,
    daysShort: app.$t('message.common.weekdayShorts', language),
    monthNames: app.$t('message.common.months', language),
    days: app.$t('message.common.weekdays', language),
  });

  // Mount the app when Vue router is ready
  app.$mount('#app');
});

// Expose the app in test mode
if (window.Cypress) {
  window.app = app;
}
